import { useState } from "react";
import { useSendWhatsAppIntroWebsiteMutation } from "../slices/whatsAppApiSlice";
import { Form, Button, Card } from "react-bootstrap";
import { toast } from "react-toastify";

const WhatsAppIntroWebsite = () => {
  const [numbersText, setNumbersText] = useState("");
  const [sendIntro] = useSendWhatsAppIntroWebsiteMutation();

  const handleSend = async () => {
    const phoneNumbers = numbersText
      .split("\n")
      .map(n => n.trim())
      .filter(n => n.length >= 10);

    if (phoneNumbers.length === 0) {
      toast.error("Please enter valid phone numbers");
      return;
    }

    try {
      sendIntro({ phoneNumbers })
        .unwrap()
        .then(() => toast.success("Intro message sent successfully", {autoClose: 1000}))
        .catch((err) => {
            console.log("RTK Mutation Error:", err);
        });
    } catch {
      toast.error("Failed to send messages", {autoClose: 2000});
    }
  };

  return (
    <Card className="p-3">
      <h4>Send Website Intro Message to Customers</h4>

      <Form.Group className="mb-3">
        <Form.Label>Enter numbers (one per line):</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          value={numbersText}
          onChange={(e) => setNumbersText(e.target.value)}
          placeholder={`Ex:\n9390595210\n9876543210\n9123456789`}
        />
      </Form.Group>

      <Button variant="success" onClick={handleSend}>
        Send WhatsApp Website Intro Message
      </Button>
    </Card>
  );
};

export default WhatsAppIntroWebsite;